import * as React from 'react'
import { Column } from '../types'

interface NumberInputProps {
  column: Column
  value: string | number | string[] | number[] | null
  onChange: (value: number | null) => void
  fieldId: string
}

export default function NumberInput({
  column,
  value,
  onChange,
  fieldId,
}: NumberInputProps) {
  const { min, max } = column.settings
  // Normalize value for input element (handle arrays gracefully)
  const inputValue = value === null || Array.isArray(value) ? '' : value

  return (
    <input
      id={fieldId}
      type="number"
      className="form-control"
      value={inputValue}
      onChange={(e) =>
        onChange(e.target.value === '' ? null : Number(e.target.value))
      }
      required={column.required}
      min={min}
      max={max}
      step="any"
    />
  )
}
